import VueCookies from "vue-cookies"
import BespinSso from "@/services/sso/bespinsso"

const bespinsso = new BespinSso();

const ssoService = {
  init(apiGwUrl) {
    return bespinsso.init(apiGwUrl);
  },

  isLoggedIn() {
    return bespinsso.getKeycloak().authenticated;
  },

  getKeycloak() {
    return bespinsso.getKeycloak();
  },

  login() {
    return new Promise((resolve, reject) => {
      const locale = VueCookies.get('BSP_LangCode') || 'en';
      bespinsso.getKeycloak().login({locale: locale});
    });
  },

  logout(options) {
    return new Promise((resolve, reject) => {
      bespinsso.getKeycloak().logout(options);
    });
  },

  logoutAllSession(withoutCurrent = false) {
    return bespinsso.logoutAllSession(withoutCurrent);
  }
};

export default ssoService;



// WEBPACK FOOTER //
// ./src/services/common/keycloak.service.js